var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { map, tap, distinctUntilChanged, take } from 'rxjs/operators';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { JwtService } from './jwt.service';
import { Apollo } from 'apollo-angular';
import { LoginGQL, MeGQL } from '../graphql';
import { ErrorHandlingService } from './error-handling.service';
// import { Store } from '@ngrx/store';
import * as Sentry from '@sentry/browser';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./jwt.service";
import * as i3 from "@angular/router";
import * as i4 from "../graphql/index";
import * as i5 from "./error-handling.service";
var AuthService = /** @class */ (function () {
    function AuthService(apollo, jwtService, router, loginGQL, meGQL, errorHandlingService) {
        this.apollo = apollo;
        this.jwtService = jwtService;
        this.router = router;
        this.loginGQL = loginGQL;
        this.meGQL = meGQL;
        this.errorHandlingService = errorHandlingService;
        this.currentUserSubject = new BehaviorSubject({});
        this.currentUser = this.currentUserSubject
            .asObservable()
            .pipe(distinctUntilChanged());
        this.isAuthenticatedSubject = new ReplaySubject(1);
        this.isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
        this.userGroupSubject = new ReplaySubject(1);
        this.userGroup$ = this.userGroupSubject.asObservable();
    }
    AuthService.prototype.attemptAuth = function (_a) {
        var _this = this;
        var credentials = _a.credentials;
        return this.loginGQL
            .mutate({
            email: credentials.email,
            password: credentials.password,
        })
            .pipe(map(function (response) { return response.data.login; }), 
        // skipWhile(data === null),
        tap(function (data) {
            if (data != null) {
                _this.errorHandlingService.errors.next({});
                _this.setAuth(data);
            }
        }));
    };
    AuthService.prototype.setAuth = function (user) {
        this.jwtService.saveToken(user.token);
        this.currentUserSubject.next(user);
        this.isAuthenticatedSubject.next(true);
        this.userGroupSubject.next(user.ruolo ? user.ruolo.nome : 'Cliente');
        Sentry.configureScope(function (scope) {
            scope.setUser({ email: user.email, username: user.username });
        });
    };
    AuthService.prototype.purgeAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.router.navigateByUrl('login');
                        this.jwtService.destroyToken();
                        this.currentUserSubject.next({});
                        this.isAuthenticatedSubject.next(false);
                        this.userGroupSubject.next('cliente');
                        window.localStorage.setItem('layout', 'grid');
                        window.localStorage.setItem('fluid', 'false');
                        window.localStorage.setItem('limit', '10');
                        window.localStorage.setItem('isNavbarOpen', 'false');
                        this.errorHandlingService.errors.next([]);
                        return [4 /*yield*/, this.apollo.getClient().resetStore()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.populate = function () {
        var _this = this;
        if (this.jwtService.getToken()) {
            this.meGQL
                .watch({}, { fetchPolicy: 'network-only' })
                .valueChanges.pipe(take(1))
                .subscribe(function (response) {
                if (!response.errors) {
                    _this.setAuth(response.data.me);
                }
                else {
                    console.log(response.errors);
                    _this.purgeAuth();
                    throw new Error('Token non valido');
                }
            }, function (err) {
                console.log(err);
                _this.purgeAuth();
                throw new Error('Token non valido');
            });
        }
        else {
            this.purgeAuth();
        }
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.Apollo), i0.inject(i2.JwtService), i0.inject(i3.Router), i0.inject(i4.LoginGQL), i0.inject(i4.MeGQL), i0.inject(i5.ErrorHandlingService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
